import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-paper py-20 md:py-28" aria-labelledby="faq-title" data-id="element-33" data-mp="1lc231ky1rhuv">
      <div className="mx-auto max-w-content px-5 md:px-8" data-id="element-34" data-mp="1ge8vool0cht0">
        <div className="grid gap-10 lg:grid-cols-[minmax(0,0.6fr)_minmax(0,1.4fr)] lg:gap-16" data-id="element-35" data-mp="2e0zgnarbcqha">
          <h2 id="faq-title" className="text-4xl font-extrabold tracking-tightest text-ink md:text-5xl" data-id="element-36" data-mp="290tn1p1hgtwk">
            Preguntas frecuentes
          </h2>

          <div className="border-t border-line" data-id="element-37" data-mp="1z3ffyg1g9hgx">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <div key={faq.question} className="border-b border-line" data-id="element-38" data-mp="sl0favgagdzq" data-mpi={index}>
                  <h3 data-id="element-39" data-mp="nn8qwbeura0a">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-40" data-mp="nq4mht389mlk">
                      <span className="text-lg font-bold leading-snug tracking-tight text-ink" data-id="element-41" data-mp="6rg9dhnnza9l">
                        {faq.question}
                      </span>
                      <PlusIcon className={['mt-1 h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out', isOpen ? 'rotate-45' : 'rotate-0'].join(' ')} aria-hidden="true" data-id="element-42" data-mp="bjhln3ku10zm" />
                    </button>
                  </h3>
                  <AnimatePresence initial={false} data-id="element-43" data-mp="3nz20c770ruv8">
                    {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-44" data-mp="1uhmk7cpm2jjh">
                        <p className="max-w-2xl pb-6 pr-10 text-base leading-relaxed text-ink-muted" data-id="element-45" data-mp="2dexeeiwdyms2">
                          {faq.answer}
                        </p>
                      </motion.div> : null}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}